import { Heart } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";
import { toast } from "sonner";

export const WishlistButton = ({ product, className = "" }) => {
  const { has, toggle } = useWishlist();
  const active = has(product.id);

  const onClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const added = await toggle(product.id);
    toast(added ? `${product.name} saved to wishlist` : `${product.name} removed from wishlist`);
  };

  return (
    <button
      data-testid={`wishlist-toggle-${product.slug}`}
      onClick={onClick}
      aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
      className={`p-2 transition-colors ${active ? "text-capra-copper" : "text-capra-ivory/70 hover:text-capra-bronze"} ${className}`}
    >
      <Heart size={18} strokeWidth={1.5} fill={active ? "currentColor" : "none"} />
    </button>
  );
};
